export enum CurrencySign {
  EUR = '€', USD = '$',
}
